import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export function TableHeader(props: { sortOrder?: 'asc' | 'desc'; title: string; column: string; }) {
    const [searchParams] = useSearchParams({});

    var newSearchParams = new URLSearchParams(searchParams);

    newSearchParams.set('sortColumn', props.column);
    newSearchParams.set('sortOrder', props.sortOrder == 'asc' ? 'desc' : 'asc');

    const toObject = { search: newSearchParams.toString() };

    return (
        <th>
            <Link to={toObject}>
                {props.title}
            </Link>
            &nbsp;
            {props.sortOrder == 'asc' && (<i className="bi bi-sort-down-alt"></i>)}
            {props.sortOrder == 'desc' && (<i className="bi bi-sort-up"></i>)}
        </th>);
}
